import { type Commands } from '../../../core/context/commands';
import { UUID } from '../../../core/context/uuid/entity';
import { ProtectionGoals } from './repository';
import { ProtectionGoal } from './entity';
import { type ProtectionGoalData } from './dto';

export class ProtectionGoalsCommands
    implements Commands<ProtectionGoals, ProtectionGoal, ProtectionGoalData>
{
    addAll(repo: ProtectionGoals, data: ProtectionGoalData[]): ProtectionGoals {
        data.forEach((protectionGoalData) => {
            this.add(repo, protectionGoalData);
        });
        return repo;
    }

    add(repo: ProtectionGoals, data: ProtectionGoalData): ProtectionGoals {
        const protectionGoal = new ProtectionGoal({
            id: data.id,
            name: data.name,
        });
        repo.add(protectionGoal);
        return repo;
    }

    update(repo: ProtectionGoals, entity: ProtectionGoal): ProtectionGoal {
        repo.update(entity);
        return entity;
    }

    remove(repo: ProtectionGoals, id: string): void {
        repo.remove(id);
    }

    create(
        repo: ProtectionGoals,
        data: Omit<ProtectionGoalData, 'id'>,
    ): ProtectionGoal {
        const uuid = new UUID();
        const protectionGoal = new ProtectionGoal({
            id: uuid.toString(),
            name: data.name,
        });
        repo.add(protectionGoal);
        return protectionGoal;
    }

    fromJSON(
        entity: ProtectionGoal[],
        changeCallback: () => void,
    ): ProtectionGoals {
        const newProtectionGoals = new ProtectionGoals(changeCallback);
        entity.forEach((protectionGoal) => {
            newProtectionGoals.add(
                new ProtectionGoal({
                    id: protectionGoal.id,
                    name: protectionGoal.name,
                    capabilities: protectionGoal.capabilities,
                }),
            );
        });
        return newProtectionGoals;
    }
}
